import axios from 'axios';

const referenceStore = {
    namespaced: true,
    state: {
        reference: {},
        scholarship: {},
        application: {},
        referenceStatus: 0,
        scholarshipStatus: 0,
        exception: '',
        apiresult: {}
    },
    actions: {
        async fetchReference({commit, dispatch, rootGetters}, {refId}) {
            try {
                console.log('into fetchReference try');
                console.log(rootGetters['user/token']);
                console.log('refID');
                console.log(refId);
                const res = await fetchData(`/api/references/${refId}`, rootGetters['user/token']);
                //const res = await fetchData(`/api/references/${refId}`);1234
                console.log('into fetchReference try2');
                commit('updateData', {key: 'referenceStatus', payload: res.status});
                if(res.status === 200) {
                    commit('updateData', {key: 'reference', payload: res.data});
                    await dispatch('fetchApplication', {appId: res.data['Scholarship_Application__c']})
                }
                console.log('Res status');
                console.log(res.status);
            } catch(e) {
                console.log('into fetchReference catch');
                console.log(e)
                commit('updateData', {key: 'referenceStatus', payload: 500});
            }
        },

        async fetchScholarship({commit, rootGetters}, {schlrId}) {
            try {
                console.log('into fetchScholarship try');
                const res = await fetchData(`/api/references/scholarship/${schlrId}`, rootGetters['user/token']);
                console.log('into fetchScholarship try2');
                console.log(res);
                commit('updateData', {key: 'scholarshipStatus', payload: res.status});
                if(res.status === 200) {
                    const scholarship = res.data
                    scholarship['Scholarship_Application__c.Status__c'] = rootGetters['reference/reference']['Feedback_Submitted__c'] ? 'Reference submitted' : 'Reference requested'
                    commit('updateData', {key: 'scholarship', payload: scholarship});
                }
            } catch(e) {
                console.log('into fetchScholarship catch');
                console.log(e);
                commit('updateData', {key: 'scholarshipStatus', payload: 500});
            }
        },

        async fetchApplication({commit, dispatch, rootGetters}, {appId}){
            try {
                console.log('into fetchApplication try');
                const res = await fetchData(`/api/references/application/${appId}`, rootGetters['user/token']);
                console.log('into fetchApplication try2');
                if(res.status === 200) {
                    commit('updateData', {key: 'application', payload: res.data});
                    await dispatch('fetchScholarship', {schlrId: res.data['Scholarship__c']})
                }
            } catch(e) {
                console.log('into fetchApplication catch');
                console.log(e);
            }
        },
        async saveReference({commit, rootGetters}, {payload}){
            console.log('into saveReference try');
            commit('updateData', {key: 'reference', payload: payload})
            try {
                //console.log('rootGetters[reference/reference]');
                //console.log(rootGetters['reference/reference']);
                //console.log('rootGetters[user/token]');
                //console.log(rootGetters['user/token']);
                //await postData(`/api/references`, rootGetters['reference/reference'], rootGetters['user/token'])
                await new Promise((resolve, reject) => {
                    setTimeout(() => {
                        var result = postData(`/api/references`, rootGetters['reference/reference'], rootGetters['user/token']);
                        if(!result) {
                            //commit('updateData', {key: 'exception', payload: '500'});
                            //this.state.exception = '500';
                            console.log('save reference failed, no result');
                            reject ('no result');
                        } else {
                            commit('updateData', {key: 'apiresult', payload: result});
                            //this.state.apiresult = result;
                            console.log('save reference finished');
                            console.log(result);
                            resolve (result);
                        }
                    }, 1000)
                }).then(response=>{
                    console.log('then');
                    commit('updateData', {key: 'exception', payload: '200'});
                    console.log(response);})
                .catch(error=>{
                    console.log('error');
                    commit('updateData', {key: 'exception', payload: '500'});
                    console.log(error);
                });




            } catch (e) {
                console.log('into saveReference catch');
                console.log(e)
                commit('updateData', {key: 'apiresult', payload: e});
            }
        }
    },
    mutations: {
        updateData(state, {key, payload}) {
            state[key] = payload;
        }
    },
    getters: {
        reference: state =>  state.reference,
        referenceStatus: state => state.referenceStatus,
        scholarship: state => state.scholarship,
        scholarshipStatus: state => state.scholarshipStatus,
        exception: state => state.exception,
        apiresult: state => state.apiresult,
    }
}


function fetchData(url, token) {
    return axios.get( url,
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }
    )
}

function postData(url, payload, token) {
    
    return axios.put(url,payload,
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }
    )
    
   /*
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            var result = axios.put(url,payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                }
            ); 
            if(!result) {
                //this.$store.commit('reference/updateData', {key: 'exception', payload: '500'});
                this.state.exception = '500';
                console.log('save reference failed, no result');
                reject ('no result');
            } else {
                //this.$store.commit('reference/updateData', {key: 'apiresult', payload: result});
                this.state.apiresult = result;
                console.log('save reference success');
                console.log(result);
                resolve (result);
            }
        }, 1000)
    })
    */
}

export default referenceStore;
